<h1 mat-dialog-title>{{ 'EDITOR.CAPTUREPHOTO' | translate}}</h1>
<mat-dialog-content >
  <mat-form-field>
    <mat-label>{{ 'CAMERA.SELECTCAM' | translate}}</mat-label>
    <mat-select [(ngModel)]="selectedCamera" name="camera" (selectionChange)="switchCamera($event.value)">
      @for (camera of cameras; track camera) {
        <mat-option  [value]="camera">{{camera.label}}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  <video [class.hidden]="errorMessage" maxWidth width="100%" #video  autoplay muted playsinline> </video>
  @if (errorMessage) {
    <mat-card>
      <mat-card-content>{{errorMessage}}</mat-card-content>
    </mat-card>
  }

  <canvas [width]="canvasWidth" [height]="canvasHeight" #canvas ></canvas>
</mat-dialog-content>

<mat-dialog-actions>
  <button (click)="abort()" mat-button [mat-dialog-close]="true" >{{'DIALOGS.CANCEL' | translate}}</button>
  @if (!photo) {
    <button [disabled]="errorMessage.length || false" (click)="capture()" mat-button cdkFocusInitial>{{'DIALOGS.SNAPSHOT' | translate}}</button>
  }
  @if (photo) {
    <button (click)="release()" mat-button >{{'DIALOGS.RELEASE' | translate}}</button>
  }
  <button [disabled]="!photo || errorMessage.length || false" (click)="paste()" mat-button [mat-dialog-close]="true">{{'DIALOGS.PASTE' | translate}}</button>
</mat-dialog-actions>
